import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { StoreProvider } from "@/context/StoreContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ShopDrawer from "@/components/ShopDrawer";
import SearchOverlay from "@/components/SearchOverlay";
import LoginModal from "@/components/LoginModal";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import AccountPage from "@/pages/AccountPage";
import NotServiceablePage from "@/pages/NotServiceablePage";
import PolicyPage from "@/pages/PolicyPage";
import ContactPage from "@/pages/ContactPage";
import BranchesPage from "@/pages/BranchesPage";
import QaShippingPage from "@/pages/QaShippingPage";
import OffersPage from "@/pages/OffersPage";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  return (
    <div className="grain-overlay min-h-screen bg-forest font-sans text-cream antialiased">
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/category/:categoryId" element={<ShopPage />} />
          <Route path="/product/:productId" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/orders/:orderId" element={<OrderDetailPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/pincode-not-serviceable" element={<NotServiceablePage />} />
          <Route path="/privacy" element={<PolicyPage slug="privacy" />} />
          <Route path="/terms" element={<PolicyPage slug="terms" />} />
          <Route path="/return-policy" element={<PolicyPage slug="return-policy" />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/stores" element={<BranchesPage />} />
          <Route path="/offers" element={<OffersPage />} />
          <Route path="/qa/shipping-weights" element={<QaShippingPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <Footer />
      <ShopDrawer />
      <SearchOverlay />
      <LoginModal />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <StoreProvider>
        <Shell />
      </StoreProvider>
    </BrowserRouter>
  );
}

export default App;
